import { createReducer } from '@reduxjs/toolkit';

import SignupStorage from '../../services/SignupStorage';
import { REGISTRATION_STEP_STATUS, SignupStateType } from '../../types';
import {
  checkRegistrationStep,
  checkUploadedDocs,
  getAccessionDoc,
  getAccessionDocText,
  getStorageData,
  initRegistration,
  setProfileInfo,
  setSignupLoading,
  uploadAccessionDoc,
  uploadAgreement,
  uploadProfileDoc,
} from '../actions/signup';

const initialState: SignupStateType = {
  loading: {
    checkStep: false,
    initRegistration: false,
    code: false,
    profileInfo: false,
    uploadDoc: false,
    checkUploadedDocs: false,
    uploadAgreement: false,
    getAccessionDocText: false,
    uploadAccessionDoc: false,
    setPassword: false,
    getAccessionDoc: false,
    isPersonal: false,
  },
};

const signupReducer = createReducer(initialState, (builder) => {
  builder.addCase(checkRegistrationStep.fulfilled, (state, action) => {
    if (action.payload) {
      state.step = action.payload.status as REGISTRATION_STEP_STATUS;
    }
  });

  builder.addCase(setSignupLoading, (state, action) => {
    state.loading[action.payload.name] = action.payload.value;
  });

  builder.addCase(initRegistration.fulfilled, (state, action) => {
    if (action.payload) {
      state.registrationId = action.payload.id;
      state.phone = action.payload.phone;
      state.codeLength = action.payload.code.length;
    }
  });

  builder.addCase(getStorageData, (state, action) => {
    const data = localStorage.getItem('signup');
    if (data) {
      const typedData = JSON.parse(data) as {
        phone: string;
        verificationCodeId: string;
        codeLength: number;
        step: REGISTRATION_STEP_STATUS;
      };
      state.registrationId = typedData.verificationCodeId;
      state.phone = typedData.phone;
      state.codeLength = typedData.codeLength;
      state.step = typedData.step;
    }
  });

  builder.addCase(checkUploadedDocs.fulfilled, (state, action) => {
    if (
      action.payload
      // action.payload.documents &&
      // action.payload.documents.length > 0
    ) {
      const newDocs: Record<string, string> = {};
      action.payload.documents.forEach((doc) => {
        newDocs[doc.type] = doc.originalFilename;
      });
      state.docs = { ...newDocs };
      state.isPersonal = action.payload.isPersonal;
      // state.docs = { ...state.docs, ...newDocs };
    }
  });

  builder.addCase(uploadProfileDoc.fulfilled, (state, action) => {
    if (action.payload && action.payload.success) {
      const { type } = action.meta.arg;
      if (!state.docs) state.docs = { [type]: action.payload.fileName };
      else {
        state.docs = {
          ...state.docs,
          [type]: action.payload.fileName,
        };
      }
    }
  });

  builder.addCase(uploadAgreement.fulfilled, (state, action) => {
    if (action.payload) {
      state.isSignedDocs = action.payload.success;

      if (action.payload.success) {
        state.step = 'ACCESSION_AGREEMENT';
        SignupStorage.setKeyStorage('step', state.step);
      }
    }
  });

  builder.addCase(getAccessionDocText.fulfilled, (state, action) => {
    if (action.payload) {
      state.accessionDocText = action.payload;
    }
  });

  builder.addCase(uploadAccessionDoc.fulfilled, (state, action) => {
    if (action.payload) {
      state.isSignedDocsWithAgreement = action.payload.success;
      state.step = 'PASSWORD_CREATION';
      SignupStorage.setKeyStorage('step', 'PASSWORD_CREATION');
    }
  });

  builder.addCase(setProfileInfo.fulfilled, (state, action) => {
    if (action.payload) {
      state.step = action.payload.status;
      SignupStorage.setKeyStorage('step', state.step);
    }
  });

  builder.addCase(getAccessionDoc.fulfilled, (state, action) => {
    if (action.payload) {
      state.accessionDoc = action.payload.doc;
    }
  });
});

export default signupReducer;
